import { render, staticRenderFns } from "./CartSkeleton.vue?vue&type=template&id=66e535ae&scoped=true&"
import script from "./CartSkeleton.vue?vue&type=script&lang=js&"
export * from "./CartSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CartSkeleton.vue?vue&type=style&index=0&id=66e535ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e535ae",
  null
  
)

export default component.exports